import { render, staticRenderFns } from "./CreateAddOrSelect.vue?vue&type=template&id=6922bb1d&scoped=true"
import script from "./CreateAddOrSelect.vue?vue&type=script&lang=js"
export * from "./CreateAddOrSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6922bb1d",
  null
  
)

export default component.exports